import clsx from 'classnames'
import { forwardRef, HTMLProps } from 'react'
import { AnalyticSkeletonCard } from '@/entities/analytic-card'
import style from './analytics-list.module.scss'

interface AnalyticsLoaderProps extends HTMLProps<HTMLUListElement> {}

export const AnalyticsLoader = forwardRef<HTMLUListElement, AnalyticsLoaderProps>(({ className }, ref) => {
  return (
    <>
      {[4, 3, 2, 1].map((_, index) => (
        <AnalyticSkeletonCard className={className} key={index} index={index} />
      ))}
    </>
  )
})

AnalyticsLoader.displayName = 'AnalyticsLoader'
